import { useEffect } from 'react';
import useLatest from './use-latest';

var useUnmount = function useUnmount(fn) {
  var fnRef = useLatest(fn);
  useEffect(function () {
    return function () {
      var _a;

      (_a = fnRef.current) === null || _a === void 0 ? void 0 : _a.call(fnRef);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};

export default useUnmount;